import React from "react"
import { QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import Cookies from "js-cookie"

import { queryClient } from "./reactQuery"

type ReactQueryProviderProps = {
  children: React.ReactNode
}
const ReactQueryProvider = ({ children }: ReactQueryProviderProps) => {
  const isVisualTesting = Cookies.get("testEnvironment") === "playwright: frontend/frontend"

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!isVisualTesting && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}

export default ReactQueryProvider
